import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { CrudStore } from 'core/types/crudStore'

import { removeEmptyRows } from '../removeEmptyRows'

export const getSaveBasicData = (
  data: IELTData | undefined,
  formData: TEltFormData,
  additionalData: Partial<IELTData>
) => {
  const filteredFormData = removeEmptyRows(formData, data?.EltType)
  const crud = CrudStore.get<IELTData>(CrudStoreItemPartner360.JBPEltData)
  const saveData = {
    ...(data || {}),
    ...additionalData,
    FormData: JSON.stringify(filteredFormData),
  } as IELTData
  return { saveData, crud }
}
